@if (user) {
  @defer (on hover) {
    <ng-container>
      <div
        class="d-flex align-items-center"
        [nzTooltipOverlayStyle]="{ 'min-width': 'fit-content' }"
        [nzTooltipArrowPointAtCenter]="true"
        nz-tooltip
        [nzTooltipTitle]="userDetailsTooltip"
        [nzTooltipColor]="'#fff'"
      >
        <ng-container *ngTemplateOutlet="userDetails"></ng-container>
      </div>
    </ng-container>
  } @placeholder {
    <div class="d-flex align-items-center">
      <ng-container *ngTemplateOutlet="userDetails"></ng-container>
    </div>
  }

  <ng-template #userDetails>
    <wilson-user-avatar
      [s3Urn]="user.profileImageUrl || ''"
      class="icon-square me-1 avatar"
      [ngClass]="smallText ? 'avatar-small' : 'avatar'"
    ></wilson-user-avatar>
    <div class="px-1 w-100 text-truncate">
      <span [ngClass]="smallText ? 'user-name-small' : 'user-name'">
        {{ user.lastName + ', ' + user.firstName }}
      </span>
    </div>
  </ng-template>

  <ng-template #userDetailsTooltip>
    <wilson-user-details
      [user]="user"
      [showProfessionSection]="true"
    ></wilson-user-details>
  </ng-template>
}
